module.exports = __webpack_public_path__ + "static/media/om_wrinkles_smilelines.c819d7c3.png";